import AContainer from '../../library/ExtendedObjects/AContainer.js';

export default class IntroOrb extends AContainer
{
    constructor(scene, ind, parent)
    {
        super(scene);

        this.parentCont = parent;
        this.ind = ind;

        let orbGlow;
        let orbImg;
        let pole;
        let adj;
        let start;
        this.burst;
        this.end;
        this.type;
        if(this.ind === 1){
            this.type = 1;
            orbGlow = "LogoGlowOrange";
            orbImg = "LogoOrb2";
            pole = "LogoPole2";
            this.burst = "yellowBurst";
            adj = {x:40, y:10};
            start = {x:-145, y:-55};
            this.end = {x:-245, y:-55};
        }
        else if(this.ind === 2){
            this.type = 1;
            orbGlow = "LogoGlowOrange";
            orbImg = "LogoOrb1";
            pole = "LogoPole1";
            this.burst = "yellowBurst";
            adj = {x:7, y:39};
            start = {x:-30, y:-145};
            this.end = {x:-30, y:-245};
        }
        else if(this.ind === 3){
            this.type = 2;
            orbGlow = "LogoGlowBlue";
            orbImg = "LogoOrb3";
            pole = "LogoPole3";
            this.burst = "blueBurst";
            adj = {x:-40, y:-10};
            start = {x:147, y:45};
            this.end = {x:247, y:45};
        }
        else if(this.ind === 4){
            this.type = 2;
            orbGlow = "LogoGlowBlue";
            orbImg = "LogoOrb4";
            pole = "LogoPole4";
            this.burst = "blueBurst";
            adj = {x:-7, y:-45};
            start = {x:30, y:145};
            this.end = {x:30, y:245};
        }

        this.stalk = this.create(adj.x, adj.y, pole);
        this.glow = this.create(0, 0, orbGlow);
        this.orb = this.create(0, 0, orbImg).setDepth(2);

        this.glow.alpha = 0;

        this.startAdj = adj;
        this.startLocs = start;
        this.x = start.x;
        this.y = start.y;
    }

    particleSparks()
    {
        this.scene.playSound("electricity_shock_spark_short_01");
        
        let randAmount = Phaser.Math.Between(10, 50);

        let emitter = this.scene.add.particles(this.scene.particleAtlas, this.burst).createEmitter({
            x: { min: -20, max: 20 },
            speed: { min: -400, max: 400 },
            angle: { min: 60, max: 115 },
            scale: {start: Phaser.Math.FloatBetween(.1, .3), end: 0 },
            blendMode: 'SCREEN',//{'SCREEN' || "ADD" || "MULTIPLY"},
            lifespan: Phaser.Math.Between(200, 800),
            alpha: { min: 0, max: 1 },
            quantity: randAmount,
            maxParticles: randAmount,
        });
        this.addAt(emitter.manager, 2);
    }

    tweenInOrb()
    {
        this.scene.addTween(this, 750, {x:this.end.x, y:this.end.y}, Phaser.Math.Easing.Quadratic.Out);
    }

    flicker(oneOf)
    {
        let randHold = Phaser.Math.Between(0, 500);
        let randRepeat;

        if(oneOf){
            randRepeat = Phaser.Math.Between(0, 2);
        } else {
            randRepeat = Phaser.Math.Between(1, 4);
        }

        this.particleSparks();

        this.scene.addTween(this.glow, 50, {alpha: 1, repeat:randRepeat, onRepeat:()=>{this.particleSparks()}, yoyo:true, hold:randHold}, Phaser.Math.Easing.Quadratic.InOut,
            ()=>{this.endPulse()});
    }

    puslseGlow()
    {
        this.scene.addTween(this.glow, 300, {alpha: .75, yoyo:true, repeat:-1}, Phaser.Math.Easing.None);
    }

    endPulse()
    {
        this.glow.alpha = 1;
        this.parentCont.updatePulse(this.type);

        let randHold = Phaser.Math.Between(5000, 15000);
        this.scene.addDelay(randHold, ()=>{this.flicker(true);});
    }

    cleanUp()
    {
        this.scene.killTween(this.glow);
        
        this.stalk.destroy();
        this.glow.destroy();
        this.orb.destroy();
    }
}